import { render, staticRenderFns } from "./MobileItem.vue?vue&type=template&id=65b46290"
import script from "./MobileItem.vue?vue&type=script&lang=js"
export * from "./MobileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports